export const heroData = {
  title: "What to Expect on the Day",
  subtitle: "Here is a guide to the day-of schedule. Please review it in advance for a smooth experience.",
  image:
    "https://readdy.ai/api/search-image?query=Helicopter%20on%20helipad%20during%20golden%20hour%20sunset%20with%20warm%20lighting%2C%20pilot%20in%20uniform%20walking%20nearby%2C%20clean%20professional%20aviation%20scene%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=flowhero01&orientation=landscape",
};

export const scheduleData = {
  label: "SCHEDULE",
  title: "Day-of Schedule",
  items: [
    {
      time: "30 min before",
      title: "Arrive at the Helipad & Check In",
      desc: "Please arrive at the helipad 30 minutes before your scheduled boarding time. At check-in, we will confirm your reservation and conduct a brief safety briefing.",
    },
    {
      time: "20 min before",
      title: "Safety Briefing",
      desc: "Before boarding, you will receive a full safety briefing covering helicopter structure, emergency procedures, and in-cabin guidelines.",
    },
    {
      time: "15 min before",
      title: "Commemorative Photo (Optional)",
      desc: "Take a photo in front of the helicopter. A professional photographer option is also available.",
    },
    {
      time: "Boarding time",
      title: "Board & Take Off",
      desc: "Guided by the pilot, you will board the helicopter. Once your seatbelt is fastened, the engine starts and you lift off — and the breathtaking scenery unfolds before you.",
    },
    {
      time: "After landing",
      title: "Return & Farewell",
      desc: "After landing at the helipad, you are free to go. Commemorative photo data will be sent to you at a later date.",
    },
  ],
};

export const tipsData = {
  label: "TIPS",
  title: "Day-of Tips",
  items: [
    "Late arrivals may not be permitted to board. Please allow plenty of time.",
    "Boarding after consuming alcohol may not be permitted for safety reasons.",
    "If you are feeling unwell, please consider cancelling rather than pushing through.",
    "Make sure your camera and smartphone are fully charged before arrival.",
    "Flights may be cancelled on the day depending on weather conditions.",
  ],
};

export const finalCTA = {
  title: "Full day-of details will\nbe provided at booking",
  subtitle: "Feel free to contact us if you have any questions",
  ctas: [
    { label: "Inquire About Booking", href: "/contact", type: "primary" },
    { label: "First-Time Visitors", href: "/first-time", type: "ghost" },
  ],
};
